module.exports = {
      id: "audio-backward-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#audio-backward",
      toString: function () {
        return this.url;
      }
    }